/**
 * Gets the router from an Element. The router is
 * add globally to the Element prototype
 *
 * @param Element
 * @returns {router}
 */
export default function getRouter(Element) {
    return Element.__kompo__.router;
}
//# sourceMappingURL=getRouter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/getRouter.js
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11